export const GET_CELL_MODEM_LIST_REQUEST = 'GET_CELL_MODEM_LIST_REQUEST';
export const GET_CELL_MODEM_LIST_SUCCESS = 'GET_CELL_MODEM_LIST_SUCCESS';
export const GET_CELL_MODEM_LIST_FAILURE = 'GET_CELL_MODEM_LIST_FAILURE';

export const EXTEND_DATA_PLAN_REQUEST = 'EXTEND_DATA_PLAN_REQUEST';
export const EXTEND_DATA_PLAN_SUCCESS = 'EXTEND_DATA_PLAN_SUCCESS';
export const EXTEND_DATA_PLAN_FAILURE = 'EXTEND_DATA_PLAN_FAILURE';

export const GET_PRICES_REQUEST = 'GET_PRICES_REQUEST';
export const GET_PRICES_SUCCESS = 'GET_PRICES_SUCCESS';
export const GET_PRICES_FAILURE = 'GET_PRICES_FAILURE';

export const GET_FEEDBACK_REQUEST = 'GET_FEEDBACK_REQUEST';
export const GET_FEEDBACK_SUCCESS = 'GET_FEEDBACK_SUCCESS';
export const GET_FEEDBACK_FAILURE = 'GET_FEEDBACK_FAILURE';

export const POST_FEEDBACK_REQUEST = 'POST_FEEDBACK_REQUEST';
export const POST_FEEDBACK_SUCCESS = 'POST_FEEDBACK_SUCCESS';
export const POST_FEEDBACK_FAILURE = 'POST_FEEDBACK_FAILURE';

export const RESET_SNACKBAR = 'RESET_SNACKBAR';

export const SEARCH_OBJ = {
  imei: { text: '', order_by: '' },
  site_id: { text: '', order_by: '' },
  site_name: { text: '', order_by: '' },
  plan_end_dt: { text: '', order_by: '' },
  days_to_expiry: { text: '', order_by: '' },
  current_plan_status: { text: '', order_by: '' },
  envoy_serial_num: { text: '', order_by: '' },
  payment_status: { text: '', order_by: '' },
  last_purchase_dt: { text: '', order_by: '' },
  site_address: { text: '', order_by: '' },
};
